"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterFormData = void 0;
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
const ExtraFiltersEnum_1 = __importDefault(require("@react/web/Listing/Filter/ExtraFiltersEnum"));
class FilterFormData {
    constructor(mileage, winterTires, inquiryType, contractLength, make, model, body, fuel, extra, equipment, availability) {
        this.mileage = mileage;
        this.winterTires = winterTires;
        this.inquiryType = inquiryType;
        this.contractLength = contractLength;
        this.make = make;
        this.model = model;
        this.body = body;
        this.fuel = fuel;
        this.extra = extra;
        this.equipment = equipment;
        this.availability = availability;
    }
    getSelectedMakes() {
        return this.make.filter((item) => item.active === true);
    }
    getSelectedModels() {
        return this.model.filter((item) => item.active === true);
    }
    getSelectedBodyTypes() {
        return this.body.filter((item) => item.active === true);
    }
    getSelectedEquipments() {
        return this.equipment.filter((item) => item.active === true);
    }
    getSelectedExtras() {
        return this.extra.filter((item) => item.active === true);
    }
    isSelectedExtrasAllWheelDrive() {
        return this.extra.filter((item) => item.active === true && item.value === ExtraFiltersEnum_1.default.allWheelDrive).length === 1;
    }
    isSelectedExtrasGearChanging() {
        return this.extra.filter((item) => item.active === true && item.value === ExtraFiltersEnum_1.default.automat).length === 1;
    }
    getSelectedMileages() {
        return this.mileage.filter((item) => item.active === true);
    }
    getSelectedInquiryTypes() {
        return this.inquiryType.filter((item) => item.active === true);
    }
    geFixtermInquiryTypeItem() {
        return this.inquiryType.filter((item) => item.value === PageHelper_1.InquiryOfferTypesEnum.FIXTERM)[0];
    }
    isFixtermInquiryTypeSelected() {
        return this.getSelectedInquiryTypes().filter((item) => item.value === PageHelper_1.InquiryOfferTypesEnum.FIXTERM).length > 0;
    }
    getSelectedContractLengths() {
        return this.contractLength.filter((item) => item.active === true);
    }
    getSelectedFuels() {
        return this.fuel.filter((item) => item.active === true);
    }
    getSelectedWinterTires() {
        return this.winterTires.filter((item) => item.active === true);
    }
    getSelectedAvailabilities() {
        return this.availability.filter((item) => item.active === true);
    }
    getEquipmentsByOrder() {
        this.equipment.sort((a, b) => {
            if (b.order === null || a.order === null) {
                return 0;
            }
            return b.order - a.order;
        });
        return this.equipment;
    }
}
exports.FilterFormData = FilterFormData;
